import TimelineVideo from "../../../../timeline/TimelineVideo/TimelineVideo";

const DIAmONDVideoPreview = require('../../../../../assets/img/timeline/modal/2018-DIAmOND.jpg');
const CHARIOTVideoPreview = require('../../../../../assets/img/timeline/modal/2018-CHARIOT.jpg');

const Content = () => {
    return (
        <>
            <div className="row">
                <div className="col-6">
                    <TimelineVideo videoId="sw25INbriFs" imagePreview={DIAmONDVideoPreview} />
                </div>
                <div className="col-6">
                    <TimelineVideo videoId="IieRpOiMchw" imagePreview={CHARIOTVideoPreview} />
                </div>
            </div>

            <h4>
                Two new world-first immunotherapy clinical trials commence called DIAmOND and CHARIOT
            </h4>

            <p>
                Breast Cancer Trials opens the DIAmOND and CHARIOT studies, which are world-first clinical trials that are both looking at how patients may benefit from immunotherapy. Immunotherapy uses the patient’s own immune system to aid in their cancer treatment and is not in routine use as a treatment option for breast cancer in Australia and New Zealand. Breast cancer researchers are learning from successful immunotherapy research results that have been seen other cancer types, such as melanoma, lung cancer and bladder cancer. They will use world-first drug combinations in these clinical trials, to see if breast cancer patients will have a positive response to immunotherapy treatments. Professor Sherene Loi is the Study Chair of both of these trials.
            </p>
        </>
    );
}

export default Content;